import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import UserPointsHitsoryItem from "./UserPointsHitsoryItem";
import { fetchPointsList, fetchReamingPointsList } from "../../actions/points";
import InfoBox from "../../components/Reusable/InfoBox";
import { fetchAllLevelList } from "../../actions/level";
import { fetchUserInfoExp } from "../../actions/security";
import { t } from "i18next"; // Import t function for translation
import ScalePercentage from "../../components/Reusable/ScalePercentage";

const calculatePercentage = (experience, levels) => {
  if (!levels || levels.length === 0) return 0;

  const numLevels = levels.length;
  const levelStep = 100 / (numLevels - 1); // Koliko % zauzima svaki nivo

  let currentLevelIndex = 0;

  for (let i = 0; i < numLevels - 1; i++) {
    if (experience < levels[i + 1].points) {
      currentLevelIndex = i;
      break;
    }
  }

  const minExp = levels[currentLevelIndex].points;
  const maxExp = levels[currentLevelIndex + 1]?.points || minExp;

  if (experience >= maxExp) return 100; // Ako je na maksimumu, 100%

  const progressInLevel = (experience - minExp) / (maxExp - minExp);
  const totalPercentage =
    currentLevelIndex * levelStep + progressInLevel * levelStep;

  return Math.min(totalPercentage, 100);
};

const calculatePercentageToNextLevel = (experience, levels) => {
  if (!levels || levels.length === 0) return 0;

  let currentLevelIndex = 0;

  // Pronalazimo trenutni nivo na osnovu experience
  for (let i = 0; i < levels.length - 1; i++) {
    if (experience < levels[i + 1].points) {
      currentLevelIndex = i;
      break;
    }
  }

  const minExp = levels[currentLevelIndex].points;
  const maxExp = levels[currentLevelIndex + 1]?.points || minExp;

  if (experience >= maxExp) return 100; // Ako je dostigao sledeći nivo, 100%

  const progressInLevel = ((experience - minExp) / (maxExp - minExp)) * 100;

  return Math.min(progressInLevel, 100);
};

const getNextLevel = (experience, levels) => {
  if (!levels || levels.length === 0) return null;

  for (let i = 0; i < levels.length - 1; i++) {
    if (experience < levels[i + 1].points) {
      return levels[i + 1]; // Sledeći nivo nakon trenutnog
    }
  }

  return levels[levels.length - 1]; // Ako je već na max nivou, vraćamo poslednji nivo
};

const getCurrentLevel = (experience, levels) => {
  if (!levels || levels.length === 0) return null;

  let currentLevel = levels[0]; // Podrazumevano postavi na prvi nivo

  for (let i = 0; i < levels.length - 1; i++) {
    if (experience < levels[i + 1].points) {
      currentLevel = levels[i];
      break;
    }
  }

  return currentLevel;
};

const UserPoints = () => {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const dispatch = useDispatch();
  const { pointsList, pointsReaming } = useSelector(
    (state) => state.pointsReducer
  );
  // const { levelAllList } = useSelector((state) => state.levelReducer);
  const [activeCategory, setActiveCategory] = useState(1);

  // const experience = loggedUserReducer?.userInfoExp?.experience;
  // const experience = 110;
  // const percentage = calculatePercentageToNextLevel(experience, levelAllList);
  // const nextLevel = getNextLevel(experience, levelAllList);
  // const currentLevel = getCurrentLevel(experience, levelAllList);

  useEffect(() => {
    dispatch(fetchPointsList());
    dispatch(fetchReamingPointsList());
    dispatch(fetchAllLevelList());
    dispatch(fetchUserInfoExp());
  }, [dispatch]);

  const today = new Date();

  // Podela liste na aktivne i istekle poene
  const activePoints = pointsList?.filter(
    (item) => new Date(item.expireDate) > today
  );
  const expiredPoints = pointsList?.filter(
    (item) => new Date(item.expireDate) <= today
  );
  return (
    <div className="user-points-main-container">
      <Breadcrumb
        title={t("userPoints.title")}
        returnPage="/profile"
        theme="dark"
      />

      <div className="user-points-content">
        <div className="user-points-main-info-header d-flex justify-content-between">
          <div className="user-points-main-info-header-text">
            <div className="user-points-content-title">
              {t("userPoints.yourPoints")}
            </div>
            <div className="user-points-content-points">
              {pointsReaming || 0}
            </div>
          </div>
          <div className="user-points-main-info-header-badge">
            <img
              src={loggedUserReducer?.userInfoExp?.levelBadge}
              className="img-fluid profile-badge-level"
              alt="LG"
            />
            <div className="user-level-name-badge text-center">
              {t(`level.${loggedUserReducer?.userInfoExp?.levelName}`)}
            </div>
          </div>
        </div>
        <div className="user-points-scale">
          {/* <ScalePercentage /> */}
          {/* <img
            src="/images/level-line-point.png"
            className="img-fluid pointer-level-line"
            alt="LG"
            style={{
              left:
                percentage > 15
                  ? `calc(${percentage}% - 15px)`
                  : `${percentage}%`,
            }}
          />
          <div className="scale-level-image-holder">
            {levelAllList.map((_, index) =>
              index < levelAllList.length - 1 ? (
                <div
                  key={index}
                  className="scale-level-image-item"
                  style={{
                    left: `${((index + 1) * 100) / levelAllList.length}%`,
                  }}
                ></div>
              ) : null
            )}
            <img src="/images/level-line.png" className="img-fluid" alt="LG" />
          </div>
          <div className="user-points-scale-level-items">
            {levelAllList.map((level) => (
              <div key={level.points} className="user-points-scale-level-item">
                {level.name}
              </div>
            ))}
          </div> */}
          {/* <div className="scale-percentage-next-level">
            <div className="scale-percentage-next-level-holder">
              <div
                className="scale-percentage-next-level-item-text"
                style={{ left: `calc(50% - 15px)` }} // Centriranje teksta
              >
                {percentage}%
              </div>
              <div
                className="scale-percentage-next-level-item"
                style={{ width: `${percentage}%` }}
              ></div>
            </div>
          </div> */}
          {/* <div className="scale-percentage-next-level">
            <div className="scale-percentage-next-level-holder">
              <div
                className="scale-percentage-next-level-item"
                style={{ width: `${percentage}%` }}
              >
                {experience} exp / {nextLevel?.points} exp
              </div>
            </div>
          </div> */}
          {/* <div className="d-flex flex-row align-items-center justify-content-between">
            <div className="item-level-scale-percent">{currentLevel?.name}</div>
            <div className="item-level-scale-percent">{nextLevel?.name}</div>
          </div> */}
        </div>
      </div>
      <div className="user-points-list-holder">
        <div className="user-points-list-holder-title">
          {t("userPoints.summaryPoints")}
        </div>

        {/* <div className="points-list-category">
          <div className="points-list-category-items">
            <div
              className={`points-list-category-item ${
                activeCategory === 1 ? "active" : ""
              }`}
              onClick={() => setActiveCategory(1)}
            >
              {t("userPoints.activePoints")}
            </div>
            <div
              className={`points-list-category-item ${
                activeCategory === 0 ? "active" : ""
              }`}
              onClick={() => setActiveCategory(0)}
            >
              {t("userPoints.expiredPoints")}
            </div>
          </div>
        </div> */}

        <div className="user-points-list-items">
          {activeCategory === 1 ? (
            activePoints.length > 0 ? (
              activePoints.map((item) => (
                <UserPointsHitsoryItem data={item} key={item?.id} />
              ))
            ) : (
              <InfoBox text={t("userPoints.noActivePoints")} />
            )
          ) : expiredPoints.length > 0 ? (
            expiredPoints.map((item) => (
              <UserPointsHitsoryItem data={item} key={item?.id} />
            ))
          ) : (
            <InfoBox text={t("userPoints.noExpiredPoints")} />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserPoints;
